import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen: boolean;
    onSelectOther: () => void;
    onOrder: () => void;
}

function SheetFooter({ isOpen, onSelectOther, onOrder }: Props) {
    const { t } = useTranslation('shopLocation');
    return (
        <Container fullWidth spacing={2}>
            <ActionButton variant='tone' onClick={onSelectOther}>
                {t('button.selectOtherShop')}
            </ActionButton>
            <ActionButton disabled={!isOpen}
                onClick={onOrder} >
                {isOpen ? t('button.order') : t('button.preparing')}
            </ActionButton>
        </Container>
    );
}

const Container = styled(Row)`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const ActionButton = styled(Button)`
    flex: 1;
    padding: 0;
`;

export default SheetFooter;
